

























import { Vue, Component, Prop } from "vue-property-decorator";
@Component
export default class BaseInfobox extends Vue {
  @Prop() level!: string;
  @Prop() message!: string;
}
